// constants/filterKeywords.ts
export const FILTER_KEYWORDS = [
    "lên",
    "->",
    ">",
    "từ",
];